// Shared "Needs attention" panel (HR, Accounts): one row per item with icon, title/subtitle, due
// label and count. Rows with a count > 0 are clickable ("View list →") and call onOpen(row.key).
import React from 'react';
import { Loader2 } from 'lucide-react';
import { TILE_TONES } from './StatTile';

const NeedsAttentionCard = ({ subtitle, rows, loading, onOpen }) => {
    const needsActionCount = rows.filter((row) => (row.count || 0) > 0).length;

    return (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-200 dark:border-gray-700 p-4">
            <div className="flex items-start justify-between mb-1">
                <div>
                    <h3 className="text-sm font-semibold text-gray-900 dark:text-white">Needs attention</h3>
                    <p className="text-xs text-gray-400 dark:text-gray-500">{subtitle}</p>
                </div>
                {needsActionCount > 0 && (
                    <span className="text-[11px] font-medium text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-900/20 px-2 py-1 rounded-full whitespace-nowrap flex-shrink-0">
                        {needsActionCount} item{needsActionCount > 1 ? 's' : ''} needs action
                    </span>
                )}
            </div>

            <div className="divide-y divide-gray-100 dark:divide-gray-700 mt-2">
                {rows.map((row) => {
                    const count = row.count || 0;
                    const clickable = count > 0;
                    const Icon = row.icon;
                    const t = TILE_TONES[row.tone] || TILE_TONES.blue;

                    return (
                        <button
                            key={row.key}
                            disabled={!clickable}
                            onClick={() => clickable && onOpen(row.key)}
                            className={`w-full flex items-center gap-3 py-2.5 px-1 -mx-1 text-left rounded-md ${clickable ? 'hover:bg-gray-50 dark:hover:bg-gray-700/40 cursor-pointer' : 'cursor-default'
                                }`}
                        >
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${t.icon}`}>
                                {loading ? <Loader2 className={`w-4 h-4 animate-spin ${t.text}`} /> : <Icon className={`w-4 h-4 ${t.text}`} />}
                            </div>
                            <div className="min-w-0 flex-1">
                                <p className="text-sm font-medium text-gray-900 dark:text-white truncate">{row.title}</p>
                                <p className="text-xs text-gray-400 dark:text-gray-500 truncate">{row.subtitle}</p>
                            </div>
                            <span className="text-xs text-gray-400 dark:text-gray-500 flex-shrink-0 hidden sm:block">{row.dueLabel}</span>
                            <span className={`text-lg font-bold w-6 text-right flex-shrink-0 ${count > 0 ? t.text : 'text-gray-300 dark:text-gray-600'}`}>
                                {count}
                            </span>
                            <span className={`text-xs font-medium flex-shrink-0 w-16 text-right ${clickable ? 'text-blue-600 dark:text-blue-400' : 'text-green-600 dark:text-green-500'}`}>
                                {clickable ? 'View list →' : 'All clear'}
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default NeedsAttentionCard;
